<template>
    <v-container grid-list-md text-center>
        <v-layout wrap>
            <v-flex xs12>
                <v-card color="grey lighten-5" class="mb-10" height="auto">
                    <v-flex xs11 sm11 class="text-left">
                        <h3>Gestion des utilisateurs</h3>
                    </v-flex>
                    <v-flex xs12 sm8 offset-sm1>
                    </v-flex>                    
                    <v-card-title>
                        <h5>Utilisateurs :</h5>
                        <v-spacer></v-spacer>
                        <v-text-field
                            v-model="$store.state.searchUsersList"
                            append-icon="mdi-magnify"
                            label="Recherche"
                            single-line
                            hide-details>
                        </v-text-field>															
                    </v-card-title>
                    <v-data-table
                        :headers="$store.state.UsersHeaders"
                        :items="$store.state.usersListBool"
                        :items-per-page="15"
                        :single-select="true"
                        :search="$store.state.searchUsersList"
                        :dense = true
                        item-key="ID"
                        class="elevation-1"
                    >
                        <template v-slot:top>
                            <v-toolbar
                                flat
                            >
                            <v-spacer></v-spacer>
                            <v-dialog
                                v-model="dialog"
                                max-width="500px"
                            >
                                <template v-slot:activator="{ on, attrs }">
                                <v-btn
                                    color="primary"
                                    dark
                                    class="mb-1"
                                    v-bind="attrs"
                                    v-on="on"
                                >
                                    +
                                </v-btn>
                                </template>
                                <v-card>
                                <v-card-title>
                                    <span class="text-h5">{{ formTitle }}</span>
                                </v-card-title>
                    
                                <v-card-text>
                                    <v-container>
                                    <v-row>
                                        <v-col
                                        cols="12"
                                        sm="6"
                                        md="5"
                                        >
                                        <v-text-field
                                            v-model="editedItem.NOM"
                                            label="Nom (*)"
                                            :rules="[() => !!editedItem.NOM || 'Ce champ est obligatoire !']"
                                            :error-messages="errorMessages"
                                            required
                                        ></v-text-field>
                                        </v-col>
                                        <v-col
                                        cols="12"
                                        sm="6"
                                        md="5"
                                        >
                                        <v-text-field
                                            v-model="editedItem.PRENOM"
                                            label="Prenom (*)"
                                            :rules="[() => !!editedItem.PRENOM || 'Ce champ est obligatoire !']"
                                            :error-messages="errorMessages"
                                            required
                                        ></v-text-field>
                                        </v-col>
                                        <v-col
                                        cols="12"
                                        sm="9"
                                        md="8"
                                        >
                                        <v-text-field
                                            v-model="editedItem.EMAIL"
                                            label="Email (*)"
                                             :rules="[() => !!editedItem.EMAIL || 'E-mail obligatoire',
                                                !editedItem.EMAIL || /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,4})+$/.test(editedItem.EMAIL) || 'E-mail invalide'
                                             ]"
                                            :error-messages="errorMessages"
                                            required
                                       ></v-text-field>
                                        </v-col>
                                        <v-col
                                        cols="12"
                                        sm="2"
                                        md="2"
                                        >
                                        <v-checkbox
                                            v-model="editedItem.ADMIN"
                                            label="Admin"
                                        ></v-checkbox>
                                        </v-col>
                                    </v-row>
                                    </v-container>
                                </v-card-text>
                    
                                <v-card-actions>
                                    <v-spacer></v-spacer>
                                    <v-btn
                                        color="blue darken-1"
                                        text
                                        @click="close"
                                    >
                                        Annuler
                                    </v-btn>
                                    <v-btn v-if="editedItem.NOM != '' && editedItem.PRENOM != '' && editedItem.EMAIL != ''" color="blue darken-1"
                                        text
                                        @click="save"
                                    >
                                        Enregistrer
                                    </v-btn>
                                </v-card-actions>
                                </v-card>
                            </v-dialog>
                            <v-dialog v-model="dialogDelete" max-width="500px">
                                <v-card>
                                <v-card-title class="text-h5">Voulez-vous supprimer cet utilisateur ?</v-card-title>
                                <v-card-text>
                                    {{ editedItem.NOM }} {{ editedItem.PRENOM }} : {{ editedItem.EMAIL }}
                                </v-card-text>
                                <v-card-actions>
                                    <v-spacer></v-spacer>
                                    <v-btn color="blue darken-1" text @click="closeDelete">Annuler</v-btn>
                                    <v-btn color="blue darken-1" text @click="deleteItemConfirm">OK</v-btn>
                                    <v-spacer></v-spacer>
                                </v-card-actions>
                                </v-card>
                            </v-dialog>
                            </v-toolbar>
                        </template>
                        <template v-slot:item.actions="{ item }">
                            <v-icon
                            small
                            class="mr-2"
                            @click="editItem(item)"
                            >
                            mdi-pencil
                            </v-icon>
                            <v-icon
                            small
                            @click="deleteItem(item)"
                            >
                            mdi-delete
                            </v-icon>
                        </template>
                        <template v-slot:item.ADMIN="{ item }">
                        <v-simple-checkbox
                            v-model="item.ADMIN"
                            disabled
                        ></v-simple-checkbox>
                        </template>
                    </v-data-table>
                </v-card>
            </v-flex>
        </v-layout>
    </v-container>
</template>

<script>
	import axios from 'axios';
	
	export default {
		name: "GestionUtilisateurs",

		data: function () {
			return {
                dialog: false,
                dialogDelete: false, 
                editedIndex: -1,
                errorMessages: '',
                formHasErrors: false,
                editedItem: {
                    NOM: '',
                    PRENOM: '',
                    EMAIL: '',
                    ADMIN: false,
                },
                defaultItem: {
                    NOM: '',
                    PRENOM: '',
                    EMAIL: '',
                    ADMIN: false,
                },
            }
        },
        computed: {
            formTitle () {
                return this.editedIndex === -1 ? 'Nouvel utilisateur' : 'Modifier l\'utilisateur'
            },
        },

        watch: {
            dialog (val) {
                val || this.close()
            },
            dialogDelete (val) {
                val || this.closeDelete()
            },
        },                        
        mounted() {
            this.createUsersListBool();        
        },
		methods: {
            createUsersListBool() {
                this.$store.state.usersListBool = [];
                this.$store.state.usersList.forEach((value) => {
                    if(value.ADMIN == "0") {
                        value.ADMIN = false;
                    } else {
                        value.ADMIN = true;
                    }
                    this.$store.state.usersListBool.push(value);
                });
            },
			getColor(admin) {
				if (admin == 0)
					return "red";
				else
					return "green";
			},
            editItem (item) {
                this.editedIndex = this.$store.state.usersListBool.indexOf(item)
                this.editedItem = Object.assign({}, item)
                this.dialog = true
            },

            deleteItem (item) {
                this.editedIndex = this.$store.state.usersListBool.indexOf(item)
                this.editedItem = Object.assign({}, item)
                this.dialogDelete = true
            },

            deleteItemConfirm () {
                this.$store.state.usersListBool.splice(this.editedIndex, 1)
                this.closeDelete()
                var link = "http://domoserver.ddns.net/gigamedia1/saveUsersList.php";
				this.$store.state.axios_error = "";
                var data = this.$store.state.usersListBool;
				axios.post(link, data, {
					headers: {
						"Content-Type": "application/json"
					}
				}).then(response => {
					this.$store.state.usersResponse = response;
					this.$store.state.api_status = response.data.api_status;
					this.$store.state.axios_error = "";
                    if(response.data.usersListSaved) {
                        link = "http://domoserver.ddns.net/gigamedia1/loadUsersList.php";
                        axios.get(link).then(response => {
                            this.$store.state.usersList = response.data;
                            this.createUsersListBool();
                        });
                    }
                    }).catch((error) => {
                        this.$store.state.axios_error = error;
                    });
            },

            close () {
                this.dialog = false
                this.$nextTick(() => {
                this.editedItem = Object.assign({}, this.defaultItem)
                this.editedIndex = -1
                })
            },

            closeDelete () {
                this.dialogDelete = false
                this.$nextTick(() => {
                this.editedItem = Object.assign({}, this.defaultItem)
                this.editedIndex = -1
                })
            },

            save () {
                if (this.editedIndex > -1) {
                Object.assign(this.$store.state.usersListBool[this.editedIndex], this.editedItem)
                } else {
                this.$store.state.usersListBool.push(this.editedItem)
                }
                this.close()
                var link = "http://domoserver.ddns.net/gigamedia1/saveUsersList.php";
				this.$store.state.axios_error = "";
                var data = this.$store.state.usersListBool;
				axios.post(link, data, {
					headers: {
						"Content-Type": "application/json"
					}
				}).then(response => {
					this.$store.state.usersResponse = response;
					this.$store.state.api_status = response.data.api_status;
					this.$store.state.axios_error = "";
                    if(response.data.usersListSaved) {
                        link = "http://domoserver.ddns.net/gigamedia1/loadUsersList.php";
                        axios.get(link).then(response => {
                            this.$store.state.usersList = response.data;
                            this.createUsersListBool();
                        });
                    }
                }).catch((error) => {
                    this.$store.state.axios_error = error;
                });
            },
        },		
    }
</script>
